import { render } from "./caculator.vue?vue&type=template&id=31cee5bf"
import script from "./caculator.vue?vue&type=script&lang=js"
export * from "./caculator.vue?vue&type=script&lang=js"

import "./caculator.vue?vue&type=style&index=0&id=31cee5bf&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__